exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".aclRow{\n\tpadding: 4px;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--1-2!./node_modules/postcss-loader/lib!./src/app/views/admin/subAdmin/aclStyle.css
// module id = 1890
// module chunks = 0